import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Phone, Truck } from "lucide-react";
import { useCart } from "../context/CartContext";

/**
 * App-style sticky bottom CTA bar — visible on mobile (md:hidden) on public pages only.
 * Hidden inside the dashboard shell, checkout flow, and auth pages where it would be redundant.
 */
const HIDDEN_PREFIXES = [
  "/login", "/signup", "/admin", "/driver", "/customer", "/wholesale/dashboard",
  "/wholesale/products", "/wholesale/orders", "/wholesale/login", "/wholesale/apply",
  "/checkout", "/cart", "/track", "/verify-email", "/forgot-password", "/reset-password",
];

export default function MobileStickyCTA() {
  const { count } = useCart();
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <>
      {/* Spacer so content isn't covered */}
      <div className="md:hidden h-20" aria-hidden="true" />

      <div
        className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-md border-t border-stone-200 px-3 pt-2 pb-3"
        style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
        data-testid="mobile-sticky-cta"
      >
        <div className="flex items-center gap-2">
          <Link
            to="/cart"
            data-testid="sticky-cart-btn"
            className="relative shrink-0 flex items-center justify-center rounded-2xl border-2 border-stone-200 bg-white h-12 w-12"
            aria-label="Cart"
          >
            <ShoppingBag size={20} className="text-stone-800" />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#EA580C] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                {count}
              </span>
            )}
          </Link>
          <a
            href="tel:0223734083"
            data-testid="sticky-call-btn"
            className="shrink-0 flex items-center justify-center rounded-2xl border-2 border-stone-200 bg-white h-12 w-12"
            aria-label="Call EGGMAN"
          >
            <Phone size={20} className="text-[#166534]" />
          </a>
          <Link
            to="/products"
            data-testid="sticky-order-cta"
            className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-[#EA580C] text-white font-bold h-12 hover:bg-[#c2410c] shadow-md active:scale-[0.98] transition-transform"
          >
            <Truck size={18} /> Order eggs
          </Link>
        </div>
      </div>
    </>
  );
}
